import { render, staticRenderFns } from "./LeftItem.vue?vue&type=template&id=5aef30fc&scoped=true&"
import script from "./LeftItem.vue?vue&type=script&lang=ts&"
export * from "./LeftItem.vue?vue&type=script&lang=ts&"
import style0 from "./LeftItem.vue?vue&type=style&index=0&id=5aef30fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef30fc",
  null
  
)

export default component.exports